<div
  class="modal-header d-flex justify-content-between align-items-center"
  style="
    padding: 20px 30px;
    border-bottom: 2px solid #e9ecef;
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  "
>
  <!-- Left side - Title -->
  <div style="flex: 1">
    <h4
      class="modal-title mb-0"
      style="color: #495057; font-weight: 600; font-size: 18px"
    >
      <i
        class="fas fa-microphone"
        style="margin-right: 10px; color: #007bff"
      ></i>
      AI Transcription
    </h4>
  </div>

  <!-- Center - Patient Info -->
  <div *ngIf="patientInfo" style="flex: 2; text-align: center">
    <div
      style="
        display: inline-block;
        padding: 8px 20px;
        background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
        border-radius: 25px;
        box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);
      "
    >
      <span style="color: white; font-weight: 600; font-size: 14px">
        <i class="fas fa-user" style="margin-right: 8px"></i>
        {{ patientInfo }}
      </span>
    </div>
  </div>

  <!-- Right side - Actions -->
  <div style="flex: 1; text-align: right; display: flex; align-items: center; justify-content: flex-end; gap: 8px;">
    <div style="display: flex; align-items: center; gap: 4px;">
      <button
        class="btn primary-btn"
        (click)="archiveDictation()"
        [disabled]="archiveInProgress"
        [ngbTooltip]="isArchivedSwitchChecked ? 'Unarchive' : 'Archive'"
        [openDelay]="400"
        [closeDelay]="400"
      >
        <i class="fas fa-archive" style="color: black"></i>
      </button>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="activeModal.dismiss()"
        style="
          background: none;
          border: none;
          font-size: 24px;
          color: #6c757d;
          cursor: pointer;
        "
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
  <!-- wrap main content so header/footer stay visible and body becomes scrollable -->
  </div>

  <!-- Modal body root provides overall scrolling area when content is large -->
  <div class="modal-body-root">
    <div class="modal-scroll-inner">
      <div
        [ngClass]="{
          'full-width': !transcriptionData,
          'half-width': transcriptionData
        }"
      >
        <div *ngIf="!parsedData" class="modal-body">
          <h5>Doctor Notes Loading — please wait...</h5>
        </div>

        <div *ngIf="parsedData" class="modal-body">
          <!-- Doctor Notes -->

          <div class="section-title-wrap">
            <h5>
              <button class="copy-btn" (click)="copySection('doctorNotes')">
                <i class="fas fa-thumbtack"></i>
              </button>
              Doctor Notes
            </h5>
            <div style="display: flex; align-items: center; gap: 8px;">
              <small *ngIf="recentVersion === true" style="color:#26903e">(Most Recent)</small>
              <small *ngIf="recentVersion === false" style="color:#8c232e">(Not Most Recent)</small>
              <button
                *ngIf="parsedData"
                class="btn btn-sm btn-outline-primary"
                (click)="downloadDoctorNotesPdf()"
                ngbTooltip="Download Doctor Notes as PDF"
                [openDelay]="400" [closeDelay]="400"
              >
                <i class="fas fa-file-pdf"></i> PDF
              </button>
            </div>
          </div>

          <div *ngIf="parsedData?.doctor_notes" #doctorNotes class="scrollable-content card-like full">
            <div>
              <p *ngIf="parsedData?.doctor_notes?.['History Of Present Illness']">
                <strong>History of Present Illness:</strong>
              </p>
              <p>{{ parsedData.doctor_notes["History Of Present Illness"] }}</p>

              <p *ngIf="parsedData?.doctor_notes?.['Physical Examination']">
                <strong>Physical Examination:</strong>
              </p>
              <p>{{ parsedData.doctor_notes["Physical Examination"] }}</p>

              <p *ngIf="parsedData?.doctor_notes?.['Diagnostics']">
                <strong>Diagnostics:</strong>
              </p>
              <p>{{ parsedData.doctor_notes["Diagnostics"] }}</p>

              <p *ngIf="Assessmentpoints.length">
                <strong>Assessment/Plan:</strong>
              </p>
              <p *ngFor="let point of Assessmentpoints">
                {{ point.length > 0 ? point : "" }}
              </p>
            </div>
          </div>

          <!-- Recommendations -->
          <h5>
            <button class="copy-btn" (click)="copySection('recommendations')">
              <i class="fas fa-thumbtack"></i>
            </button>
            Recommendations
          </h5>
          <div #recommendations class="scrollable-content card-like">
            <ng-container *ngIf="recommendationsData.tests?.length">
              <p><strong>Tests:</strong></p>
              <ul>
                <li *ngFor="let test of recommendationsData.tests">
                  <span *ngIf="test.related_to">{{ test.related_to }}</span
                  ><br />
                  {{ test.primary }}
                  <span *ngIf="test.secondary"> - {{ test.secondary }}</span>
                </li>
              </ul>
            </ng-container>

            <ng-container *ngIf="recommendationsData.medications?.length">
              <p><strong>Medications:</strong></p>
              <ul>
                <li *ngFor="let med of recommendationsData.medications">
                  <span *ngIf="med.related_to">{{ med.related_to }}</span
                  ><br />
                  {{ med.primary }}
                  <span *ngIf="med.secondary"> - {{ med.secondary }}</span>
                </li>
              </ul>
            </ng-container>

            <ng-container *ngIf="recommendationsData.treatments?.length">
              <p><strong>Treatments:</strong></p>
              <ul>
                <li *ngFor="let treatment of recommendationsData.treatments">
                  <span *ngIf="treatment.related_to">{{ treatment.related_to }}</span
                  ><br />
                  {{ treatment.primary }}
                  <span *ngIf="treatment.secondary">
                    - {{ treatment.secondary }}
                  </span>
                </li>
              </ul>
            </ng-container>

            <ng-container *ngIf="recommendationsData.risk_factors?.length">
              <p><strong>Risk Factors:</strong></p>
              <ul>
                <li *ngFor="let risk of recommendationsData.risk_factors">
                  <span *ngIf="risk.related_to">{{ risk.related_to }}</span
                  ><br />
                  {{ risk.primary }}
                  <span *ngIf="risk.secondary"> - {{ risk.secondary }}</span>
                </li>
              </ul>
            </ng-container>

            <p *ngIf="recommendationsData.considerations?.length">
              <strong>Considerations:</strong>
            </p>
            <p>{{ recommendationsData.considerations }}</p>

            <p
              class="empty-state"
              *ngIf="
                !recommendationsData.tests?.length &&
                !recommendationsData.medications?.length &&
                !recommendationsData.treatments?.length &&
                !recommendationsData.risk_factors?.length &&
                !recommendationsData.considerations
              "
            >
              No recommendations available.
            </p>
          </div>
          <!-- Action Items from API -->
          <ng-container *ngIf="actionItems?.length">
            <div class="section-title-wrap" style="margin-top: 18px;">
              <h5 style="margin: 0;">
                <i class="fas fa-tasks" style="color: #007bff; font-size: 14px; margin-right: 6px;"></i>
                Action Items
              </h5>
            </div>
            <br/>
            <div
              *ngFor="let item of actionItems"
              style="
                display: flex;
                align-items: flex-start;
                gap: 10px;
                padding: 10px 14px;
                margin-bottom: 8px;
                border-radius: 8px;
                border: 1px solid #e9ecef;
                background: #f8f9fa;
              "
            >
              <!-- Accepted / Rejected indicator -->
              <span
                [title]="item.order?.lcd_coverage_details ? 'Accepted' : item.rejected_ind ? 'Rejected' : 'Pending'"
                style="margin-top: 2px; flex-shrink: 0;"
              >
                <i
                  *ngIf="item.order?.lcd_coverage_details"
                  class="fas fa-check-circle"
                  style="color: #28a745; font-size: 16px;"
                ></i>
                <i
                  *ngIf="item.rejected_ind"
                  class="fas fa-times-circle"
                  style="color: #dc3545; font-size: 16px;"
                ></i>
                <i
                  *ngIf="!item.order?.lcd_coverage_details && !item.rejected_ind"
                  class="fas fa-clock"
                  style="color: #6c757d; font-size: 16px;"
                ></i>
              </span>

              <!-- Action item text -->
              <span style="flex: 1; font-size: 13px; color: #343a40; line-height: 1.5;">
                {{ item.action_item }}
              </span>

              <!-- Download buttons -->
              <div style="display: flex; flex-direction: column; gap: 5px; flex-shrink: 0;">
                <button
                  *ngIf="item.order?.lcd_coverage_details"
                  class="btn btn-sm btn-primary"
                  (click)="downloadActionItemPdf(item)"
                  ngbTooltip="Download Medical Necessity as PDF"
                  [openDelay]="400"
                  [closeDelay]="400"
                  style="white-space: nowrap;"
                >
                  <i class="fas fa-file-pdf" style="margin-right: 4px;"></i> PDF
                </button>
              </div>
            </div>
          </ng-container>

          <!-- Billing Analysis Section -->
          <ng-container *ngIf="transcriptionData">
            <div class="section-title-wrap" style="margin-top: 18px; display: flex; align-items: center; justify-content: space-between;">
              <h5 style="margin: 0;">
                <i class="fas fa-file-invoice-dollar" style="color: #007bff; font-size: 14px;"></i>
                Billing Analysis
              </h5>
              <span
                *ngIf="billingLoading"
                style="display: inline-flex; align-items: center; gap: 6px; color: #6c757d; font-size: 13px;"
              >
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Analyzing...
              </span>
              <div *ngIf="!billingLoading && billingData" style="display: flex; gap: 6px;">
                <button
                  class="btn btn-sm btn-outline-primary"
                  (click)="downloadBillingPdf()"
                  ngbTooltip="Download Billing Analysis as PDF"
                  [openDelay]="400" [closeDelay]="400"
                >
                  <i class="fas fa-file-pdf"></i> PDF
                </button>
              </div>
            </div>

            <!-- Loading -->
            <div *ngIf="billingLoading" class="card-like" style="display: flex; align-items: center; gap: 10px; color: #6c757d; font-size: 13px;">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Analyzing billing data...
            </div>

            <!-- Data -->
            <ng-container *ngIf="!billingLoading && billingData">

              <!-- CPT Codes -->
              <ng-container *ngIf="billingData.cpt_codes?.length">
                <p style="margin: 10px 0 6px; font-size: 13px;"><strong>CPT Codes</strong></p>
                <div class="billing-table-wrap">
                  <table class="billing-table">
                    <thead>
                      <tr>
                        <th>CPT Code</th>
                        <th>Description</th>
                        <th>ICD-10 Codes</th>
                        <th>Reason</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let code of billingData.cpt_codes">
                        <td><strong>{{ code.cpt_code }}</strong></td>
                        <td>{{ code.description }}</td>
                        <td>
                          <span *ngFor="let icd of code.icd10_codes; let last = last">
                            {{ icd?.code || icd }}<span *ngIf="!last">, </span>
                          </span>
                        </td>
                        <td>{{ code.reason }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ng-container>

              <!-- Add-On Codes -->
              <ng-container *ngIf="billingData.add_on_codes?.length">
                <p style="margin: 14px 0 6px; font-size: 13px;"><strong>Add-On Codes</strong></p>
                <div class="billing-table-wrap">
                  <table class="billing-table">
                    <thead>
                      <tr>
                        <th>CPT Code</th>
                        <th>Description</th>
                        <th>ICD-10 Codes</th>
                        <th>Reason</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let code of billingData.add_on_codes">
                        <td><strong>{{ code.cpt_code }}</strong></td>
                        <td>{{ code.description }}</td>
                        <td>
                          <span *ngFor="let icd of code.icd10_codes; let last = last">
                            {{ icd?.code || icd }}<span *ngIf="!last">, </span>
                          </span>
                        </td>
                        <td>{{ code.reason }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ng-container>

              <!-- Billing Report -->
              <ng-container *ngIf="billingData.billing_report">
                <p style="margin: 14px 0 6px; font-size: 13px;"><strong>Billing Report</strong></p>
                <div class="card-like" style="font-size: 13px; line-height: 1.6; white-space: pre-wrap; word-break: break-word;">
                  {{ billingData.billing_report }}
                </div>
              </ng-container>

            </ng-container>
          </ng-container>

          <!-- Activity Log / Processing Timeline -->
          <ng-container *ngIf="activityEvents?.length || activityLoading">
            <div class="section-title-wrap" style="margin-top: 18px;">
              <h5 style="margin: 0;">
                <i class="fas fa-stream" style="color: #007bff; font-size: 14px; margin-right: 6px;"></i>
                Processing Timeline
              </h5>
            </div>
            <br/>
            <app-activity-timeline [events]="activityEvents" [loading]="activityLoading"></app-activity-timeline>
          </ng-container>

        </div>
      </div>

      <!-- Vertical Rule -->
      <div *ngIf="transcriptionData" class="vr"></div>

      <!-- Transcription Section -->
      <div
        [ngClass]="{
          'full-width': !transcriptionData,
          'half-width': transcriptionData
        }"
        *ngIf="transcriptionData"
      >
        <div class="section-title-wrap">
          <h5>
            <button class="copy-btn" (click)="copySection('transcription')">
              <i class="fas fa-thumbtack"></i>
            </button>
            Transcription
          </h5>
          <button
            class="btn btn-sm btn-outline-primary"
            (click)="downloadTranscriptionPdf()"
            ngbTooltip="Download Transcription as PDF"
            [openDelay]="400" [closeDelay]="400"
          >
            <i class="fas fa-file-pdf"></i> PDF
          </button>
        </div>
        <div #transcription class="scrollable-content card-like transcript">
          <p>{{ transcriptionData }}</p>
        </div>
      </div>
    </div>
  </div>
  


<!-- Modal Footer -->
<div class="modal-footer">
  <button class="btn btn-secondary" (click)="activeModal.close()">Close</button>
</div>
